import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { RedTextButton } from 'components/buttons/RedTextButton';

export const MyActivitySeeAllButton = styled(RedTextButton)`
  margin-left: 0;
  padding: 0;
  width: auto;
  white-space: nowrap;

  ${theme.mq.phone} {
    min-width: 0;
    height: auto;
    font-size: 14px;
    line-height: 16px;
  }
`;
